<template>
  <div class="noselect">
    <v-card-title>
      Способы транспортирования пострадавшего:
    </v-card-title>
    <v-container fluid class="px-10">
      <v-row>
        <v-col cols="4">
          <v-card
            class="mx-auto d-flex flex-column justify-center align-center"
          >
            <v-img
              lazy-src="img/material/travm-1.svg"
              width="300"
              src="img/material/travm-1.svg"
              class="ma-5"
              height="300"
              contain
            ></v-img>
            <v-card-actions>
              <v-btn
                text
                color="red"
                @click="reveal1 = true"
              >
                При ранениях грудной полости
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <v-card
                v-if="reveal1"
                class="transition-fast-in-fast-out v-card--reveal"
                style="height: 100%;"
              >
                <v-card-text class="pb-0">
                  <p class="title text--primary">
                    При ранениях грудной полости:
                  </p>
                  <p class="title font-weight-light">В положении лежа или в положении полусидя</p>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-btn
                    text
                    color="red"
                    @click="reveal1 = false"
                  >
                    Закрыть
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expand-transition>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card
            class="mx-auto d-flex flex-column justify-center align-center"
          >
            <v-img
              lazy-src="img/material/travm-2.svg"
              width="400"
              height="300"
              src="img/material/travm-2.svg"
              class="ma-5"
              contain
            ></v-img>
            <v-card-actions>
              <v-btn
                text
                color="red"
                @click="reveal2 = true"
              >
                При ранениях головы
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <v-card
                v-if="reveal2"
                class="transition-fast-in-fast-out v-card--reveal"
                style="height: 100%;"
              >
                <v-card-text class="pb-0">
                  <p class="title text--primary">
                    При ранениях головы:
                  </p>
                  <p class="title font-weight-light">Полулежа или лежа на спине, боку</p>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-btn
                    text
                    color="red"
                    @click="reveal2 = false"
                  >
                    Закрыть
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expand-transition>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card
            class="mx-auto d-flex flex-column justify-center align-center"
          >
            <v-img
              lazy-src="img/material/travm-3.svg"
              width="400"
              height="300"
              src="img/material/travm-3.svg"
              class="ma-5"
              contain
            ></v-img>
            <v-card-actions>
              <v-btn
                text
                color="red"
                @click="reveal3 = true"
              >
                При ранениях нижних конечностей и живота
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <v-card
                v-if="reveal3"
                class="transition-fast-in-fast-out v-card--reveal"
                style="height: 100%;"
              >
                <v-card-text class="pb-0">
                  <p class="title text--primary">
                    При ранениях нижних конечностей и живота
                  </p>
                  <p class="title font-weight-light">В положении лежа на спине или боку</p>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-btn
                    text
                    color="red"
                    @click="reveal3 = false"
                  >
                    Закрыть
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expand-transition>
          </v-card>
        </v-col>
        <Hint></Hint>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Hint from '@/components/Hint.vue'
export default {
  data: () => ({
    reveal1: false,
    reveal2: false,
    reveal3: false
  }),
  components: {
    Hint
  }
}
</script>
<style lang="less" scoped>
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
</style>
